import React, { useState, useEffect } from 'react';

function Contact() {
    const [info, setInfo] = useState(null);

    useEffect(() => {
        fetch('http://127.0.0.1:5000/api/contact')
            .then(response => response.json())
            .then(data => setInfo(data))
            .catch(error => console.error('Error fetching contact info:', error));
    }, []);

    return (
        <div>
            <h2>Contact Us</h2>
            {info ? (
                <div>
                    <p><strong>Email:</strong> {info.email}</p>
                    <p><strong>Phone:</strong> {info.phone}</p>
                    <p><strong>Address:</strong> {info.address}</p>
                </div>
            ) : (
                <p>Loading contact information...</p>
            )}
        </div>
    );
}

export default Contact;
